import { isInRnWebView } from '../bridge/webviewBridge';

/**
 * 앱(RN 웹뷰)이 아니고 화면이 넓은 PC 브라우저인지.
 * 학원 계정을 PC에서 콘솔(/console)로 보낼지 판단하는 기준.
 */
export const DESKTOP_MIN_WIDTH = 900;

export function isDesktopWeb() {
  if (typeof window === 'undefined') return false;
  if (isInRnWebView()) return false;
  return window.innerWidth >= DESKTOP_MIN_WIDTH;
}
